/**
 * Shared transport for /api/perf/ingest producers (web vitals, long tasks, memory).
 * Fire-and-forget: never throws, never retries — perf samples are droppable.
 */
import type { ResolvedConfig } from './config.js';

const SDK = { name: 'sdk-react', version: '0.1.0' };

export function perfIngestUrl(collectorUrl: string): string {
  if (/\/api\/events\/ingest\/?$/.test(collectorUrl)) {
    return collectorUrl.replace(/\/api\/events\/ingest\/?$/, '/api/perf/ingest');
  }
  return `${collectorUrl.replace(/\/$/, '')}/api/perf/ingest`;
}

export function sendPerfEvents(
  cfg: ResolvedConfig,
  events: Record<string, unknown>[],
  beacon = false,
): void {
  if (!events.length) return;
  const body = JSON.stringify({ sdk: SDK, events });
  const u = perfIngestUrl(cfg.collectorUrl);
  try {
    if (beacon && typeof navigator !== 'undefined' && navigator.sendBeacon) {
      navigator.sendBeacon(
        `${u}?api_key=${encodeURIComponent(cfg.apiKey)}`,
        new Blob([body], { type: 'application/json' }),
      );
      return;
    }
    void fetch(u, {
      method: 'POST',
      keepalive: true,
      headers: { 'content-type': 'application/json', 'x-aris-api-key': cfg.apiKey },
      body,
    }).catch(() => {});
  } catch {
    /* never throw into the host app */
  }
}
